import { COLORING_GRID_STATUSES } from 'app-constants/coloringGrids';
import { MODAL_TYPES, useGlobalModalContext } from 'context/GlobalModal';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { firestore } from 'services';
import { Button } from 'shared/Components';
import { strings } from 'strings';

export interface DeleteButtonProps {
  id: string;
  onCompleted?(): void;
}

const modalTranslations = strings.pages.coloringGridsScreen.deleteColoringGridDialogModal;
const toastTranslations = strings.pages.coloringGridsScreen.toastMessages;

export const DeleteButton = (props: DeleteButtonProps) => {
  const { id, onCompleted } = props;
  const { showModal, hideModal } = useGlobalModalContext();

  const deleteColoringGrid = useCallback(async () => {
    try {
      await softDeleteColoringGrid(id);
      toast.success(toastTranslations.deleteColoringGridSuccess);
      hideModal();
      onCompleted?.();
    } catch (error) {
      toast.error(toastTranslations.deleteColoringGridFail);
    }
  }, [id, onCompleted]);

  const dialogModal = useCallback(() => {
    showModal(MODAL_TYPES.DIALOG_MODAL, {
      title: modalTranslations.title,
      text: modalTranslations.description,
      cancelButtonText: modalTranslations.cancel,
      submitButtonText: modalTranslations.confirm,
      onSubmit: () => deleteColoringGrid(),
    });
  }, [
    modalTranslations.title,
    modalTranslations.description,
    modalTranslations.cancel,
    modalTranslations.confirm,
    deleteColoringGrid,
  ]);

  return (
    <Button width={100} height={30} onClick={dialogModal} variant="danger">
      {strings.delete}
    </Button>
  );
};

export const softDeleteColoringGrid = async (id: string): Promise<void> => {
  const docRef = doc(firestore, 'coloringGrids', id);
  const snapshot = await getDoc(docRef);

  if (!snapshot.exists()) {
    throw new Error('Coloring grid does not exist');
  }

  await updateDoc(docRef, { status: COLORING_GRID_STATUSES.deleted });
};
